import { render, staticRenderFns } from "./MergerAcquisitionsEditView.vue?vue&type=template&id=10d0b0c8&"
import script from "./MergerAcquisitionsEditView.vue?vue&type=script&lang=ts&"
export * from "./MergerAcquisitionsEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d0b0c8')) {
      api.createRecord('10d0b0c8', component.options)
    } else {
      api.reload('10d0b0c8', component.options)
    }
    module.hot.accept("./MergerAcquisitionsEditView.vue?vue&type=template&id=10d0b0c8&", function () {
      api.rerender('10d0b0c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/mergerAcquisitions/MergerAcquisitionsEditView.vue"
export default component.exports